import { Response } from "../../types/Response.interface";
import useDebounce from "../../hooks/useDebounce";
import React, { Suspense, useState } from "react";
import { useRouter } from "next/router";
import Image from "next/future/image";
import dynamic from "next/dynamic";
import Cityoptions from "./Options";
import Link from "next/link";
import logo from "../../public/logo.svg";

const CityBar = dynamic(() => import("../CityBar"));

const Auth = dynamic(() => import("./Auth"), {
  suspense: true,
});

const Desktop: React.FC<DesktopProp> = () => {
  const router = useRouter();
  const [options, setOptions] = useState(Cityoptions);

  const _onSearch = async (value: string) => {
    const res: Response = await (await import("./city.api")).default(value);

    if (res.ok) {
      setOptions(res.data.data);
    }
  };

  const onSearch = useDebounce(_onSearch, 200);

  return (
    <div className="container mx-auto py-2 flex">
      <div className="flex-1 flex gap-5 items-center">
        <div>
          <Link  href="/">
            <a className="flex justify-center items-start">
              <Image
                priority
                src={logo}
                alt="bungalowfinder logo"
                title="BungalowFinder Logo"
              />
            </a>
          </Link>
        </div>
        <div className="w-1/2">
          <CityBar
            defaultValue="Mississauga"
            mode="screen"
            onSelect={(city) => router.push(`/city/${city}`)}
            options={options}
            onSearch={onSearch}
          />
        </div>
      </div>
      <div className="flex-1 flex justify-start items-center">
        <nav className="flex justify-between items-center w-full">
          <Link  href="/">
            <a>Home</a>
          </Link>
          <Link  href="/city/Mississauga">
            <a>Buy</a>
          </Link>
          <Link  href="/homeevaluation">
            <a>Sell</a>
          </Link>
          <Link  href="/newconstruction">
            <a>New Developments</a>
          </Link>
          <Link  href="/blogs">
            <a>Blog</a>
          </Link>
          <div>
            <Suspense
              fallback={
                <>
                  <p>Loading...</p>
                </>
              }
            >
              <Auth />
            </Suspense>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Desktop;

interface DesktopProp {}
